import { DatePipe } from '@angular/common';
import { Component, computed, effect, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { NewsArticle } from '../../../models/news-item';
import { NewsNotFoundError, NewsService } from '../../../services/news.service';

@Component({
  selector: 'app-news-article-page',
  standalone: true,
  imports: [RouterLink, DatePipe],
  templateUrl: './news-article-page.component.html',
  styleUrl: './news-article-page.component.scss'
})
export class NewsArticlePageComponent {
  private readonly news = inject(NewsService);
  private readonly titleService = inject(Title);

  /** A :slug útvonal-paraméter, a withComponentInputBinding() köti be. */
  readonly slug = input.required<string>();

  readonly article = rxResource<NewsArticle, string>({
    params: () => this.slug(),
    stream: ({ params }) => this.news.article(params)
  });

  /** Külön kezeljük a „nincs ilyen hír” és a „nem sikerült betölteni” esetet. */
  readonly notFound = computed(() => this.article.error() instanceof NewsNotFoundError);

  constructor() {
    effect(() => {
      // hasValue() nem dob hibát; a value() viszont IGEN, ha a resource error állapotban van.
      const loaded = this.article.hasValue() ? this.article.value() : undefined;
      this.titleService.setTitle(
        loaded ? `${loaded.meta.title} – Buj Battery` : 'Hírek – Buj Battery'
      );
    });
  }
}
